import { createContext, useContext, 
  useState, useCallback } from 'react';

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, 
    type = 'success', duration = 4000) => {
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev, 
      { id, message, type, duration }]);
    setTimeout(() => {
      setToasts(prev => 
        prev.filter(t => t.id !== id));
    }, duration);
  }, []);

  const removeToast = useCallback((id) => {
    setToasts(prev => 
      prev.filter(t => t.id !== id));
  }, []);

  const toast = {
    success: (msg, duration) => 
      addToast(msg, 'success', duration),
    error: (msg, duration) => 
      addToast(msg, 'error', duration || 8000),
    info: (msg, duration) => 
      addToast(msg, 'info', duration),
    warning: (msg, duration) => 
      addToast(msg, 'warning', duration),
  };

  return (
    <ToastContext.Provider 
      value={{ toast, toasts, removeToast }}>
      {children}
    </ToastContext.Provider>
  );
}

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) throw new Error(
    'useToast must be used within ToastProvider'
  );
  return context;
};
